// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".homepage-admin-hub-container{max-width:1185px!important;margin:0 auto!important;display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;position:relative}", ""]);
// Exports
module.exports = exports;
